import CustomersResellersRow from '../CustomersResellersRow'

interface RowRenderProps {
  rows: unknown[] | never[]
}

const CustomersResellersRowRender = ({ rows = [] }: RowRenderProps) =>
  rows.map((row: any) => <CustomersResellersRow row={row} key={row.id} />)

export default CustomersResellersRowRender
